import Button from '@intercom/embercom-composer/blocks/types/button';
import Html from '@intercom/embercom-composer/blocks/types/html';
import Code from '@intercom/embercom-composer/blocks/types/code';
import { computed } from '@ember/object';
import { ternary } from '@intercom/pulse/lib/computed-properties';
import ImageText from '@intercom/embercom-composer/blocks/types/image-text';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['ic-popup', 'ic-popup-left', 'is-light-theme', 'composer-media-selector'],
  classNameBindings: ['config.allowSocial:composer-media-selector-with-social'],
  caretShowStyle: ternary('showCaret', 'visible', 'hidden'),
  didInsertElement() {
    this._super(...arguments);
    this.set('showCaret', true);
  },
  willDestroyElement() {
    this._super(...arguments);
    this.set('showCaret', true);
  },
  pointerStyle: computed('elementId', 'caretShowStyle', function () {
    return `<style>#${this.elementId}:before, #${this.elementId}:after { visibility: ${this.caretShowStyle}; }</style>`;
  }),
  actions: {
    insertButton() {
      let button = Button.create({
        config: this.get('config')
      });
      let options = {
        index: this.get('hoverCoordinates.insertionIndex'),
        selectNewBlock: true
      };
      this.insertBlock(button, options);
    },
    insertHtml() {
      let html = Html.create({
        config: this.get('config')
      });
      let options = {
        index: this.get('hoverCoordinates.insertionIndex'),
        selectNewBlock: true
      };
      this.insertBlock(html, options);
    },
    insertCode() {
      let code = Code.create({
        config: this.get('config')
      });
      let options = {
        index: this.get('hoverCoordinates.insertionIndex'),
        selectNewBlock: true
      };
      this.insertBlock(code, options);
    },
    switchMode(mode) {
      this.set('mode', mode);
    },
    addImage() {
      this.openFileDialog?.('image');
    },
    addAttachment() {
      this.openFileDialog?.('attachment');
    },
    addVideoFile() {
      this.openFileDialog?.('video');
    },
    addImageText() {
      let imageText = ImageText.create({
        config: this.get('config')
      });
      let options = {
        index: this.get('hoverCoordinates.insertionIndex'),
        selectNewBlock: true
      };
      this.insertBlock(imageText, options);
    }
  }
});